const circularProgressProps = {
  size: '96',
  width: '12',
  color: 'secondary',
  rotate: '-90',
};

export default circularProgressProps;
